import { render, staticRenderFns } from "./ProcessFilters.vue?vue&type=template&id=0ca8be7b&scoped=true"
import script from "./ProcessFilters.ts?vue&type=script&lang=ts&external"
export * from "./ProcessFilters.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessFilters.vue?vue&type=style&index=0&id=0ca8be7b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca8be7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca8be7b')) {
      api.createRecord('0ca8be7b', component.options)
    } else {
      api.reload('0ca8be7b', component.options)
    }
    module.hot.accept("./ProcessFilters.vue?vue&type=template&id=0ca8be7b&scoped=true", function () {
      api.rerender('0ca8be7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/Filters/ProcessFilters/ProcessFilters.vue"
export default component.exports